import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { ButtonModule } from 'primeng/button';
import { primengImports } from '@app/core/primeng';

@Component({
  selector: 'app-reset-password',
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, ...primengImports],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  resetForm: FormGroup;
  submitted = false;
  successMessage = '';
  errorMessage = '';
  constructor(
    private fb: FormBuilder,
    private router: Router,
    public authService: AuthService
  ){
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get f() {
    return this.resetForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetForm.invalid) return;

    this.authService.requestPasswordReset(this.resetForm.value.email).subscribe({
      next: () => {
        this.successMessage = `Un lien de réinitialisation a été envoyé à ${this.resetForm.value.email}`;
        this.errorMessage = '';
      },
      error: (err) => {
        this.errorMessage = "Échec de l'envoi du lien de réinitialisation. Veuillez réessayer.";
        this.successMessage = '';
        console.error('Erreur:', err);
      }
    });
  }

  onSignIn(){
    this.router.navigate(['login']);
  }
}
